<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
	<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
		<!--			<el-form-item style="margin-bottom:0;" class="filter-item">-->
<!--				<el-input v-model="filters.label" placeholder="名称"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item style="margin-bottom:0;" class="filter-item">-->
<!--				<kt-button :label="$t('action.search')" perms="sys:tAfaViewWaveOrderLine:view" type="primary" @click="findPage(null)"/>-->
<!--			</el-form-item>-->
<!--			<el-form-item style="margin-bottom:0;" class="filter-item">-->
<!--				<kt-button :label="$t('action.add')" perms="sys:tAfaViewWaveOrderLine:add" type="primary" @click="handleAdd" />-->
<!--			</el-form-item>-->
		</el-form></div>
		<div class="action-bar">
			<kt-button :label="$t('action.search')" perms="sys:tAfaViewWaveOrderLine:view" type="primary" icon="el-icon-search" @click="findPage(null)"/>
		</div>
		</div>
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tWaveMaster:edit" permsDelete="sys:tWaveMaster:delete" permsView="sys:tWaveMaster:view" :displayButtonEdit="false" :displayButtonDelete="false" :showBatchDelete="false"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')" :pageNum=this.pageRequest.pageNum :pageSize=this.pageRequest.pageSize
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item label="" prop="userId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.userId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="viewId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.viewId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="waveId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.waveId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="orderNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.orderNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="lineNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.lineNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.itemNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="selected"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.selected" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="headerString"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.headerString" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="addWaveStatus"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.addWaveStatus" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="targetWave"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.targetWave" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="addQuantity"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.addQuantity" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="hide"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.hide" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TAfaViewWaveOrderLine',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
			filters: {
        userId: '',
        viewId: '',
        waveId: '',
        whId: '',
        orderNumber: ''
			},
			columns: [
				{prop:"userId", label:"操作用户", minWidth:100},
				{prop:"viewId", label:"查看编号", minWidth:100},
        {prop:"whId", label:"仓库号", minWidth:100},
				{prop:"waveId", label:"波次号", minWidth:100},
				{prop:"orderNumber", label:"出库订单号", minWidth:100},
				{prop:"lineNumber", label:"行号", minWidth:100},
				{prop:"itemNumber", label:"商品编码", minWidth:100},
        {prop:"addQuantity", label:"数量", minWidth:100},
				{prop:"selected", label:"是否选中", minWidth:100},
				{prop:"headerString", label:"", minWidth:100},
				{prop:"addWaveStatus", label:"", minWidth:100},
				{prop:"targetWave", label:"", minWidth:100},
				{prop:"hide", label:"", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 1000 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
				label: [
					{ required: true, message: '请输入名称', trigger: 'blur' }
				]
			},
			// 新增编辑界面数据
			dataForm: {
				userId: null,
				viewId: null,
				waveId: null,
				whId: null,
				orderNumber: null,
				lineNumber: null,
				itemNumber: null,
				selected: null,
				headerString: null,
				addWaveStatus: null,
				targetWave: null,
				addQuantity: null,
				hide: null,
}
}
	},
	methods: {
    getParentParams: function () {
      this.filters.userId=this.$route.query.userId
      this.filters.viewId=this.$route.query.viewId
      this.filters.waveId=this.$route.query.waveId
      this.filters.whId=this.$route.query.whId
      this.filters.orderNumber=this.$route.query.orderNumber
      this.findPage(null)
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let userId=this.filters.userId
      let viewId=this.filters.viewId
      let waveId=this.filters.waveId
      let whId=this.filters.whId
      let orderNumber=this.filters.orderNumber
			this.pageRequest.columnFilters = {userId: {name:'userId', value:userId},viewId:{name:"viewId",value:viewId},waveId:{name:"waveId",value:waveId},whId:{name:"whId",value:whId},orderNumber:{name:"orderNumber",value:orderNumber}}
			this.$wmsApi.tAfaViewWaveOrderLine.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 批量删除
		handleDelete: function (data) {
			this.$wmsApi.tAfaViewWaveOrderLine.batchDelete(data.params).then(data!=null?data.callback:'')
		},
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				userId: null,
				viewId: null,
				waveId: null,
				whId: null,
				orderNumber: null,
				lineNumber: null,
				itemNumber: null,
				selected: null,
				headerString: null,
				addWaveStatus: null,
				targetWave: null,
				addQuantity: null,
				hide: null,
}
},
		// 显示编辑界面
		handleEdit: function (params) {
			this.editDialogVisible = true
			this.operation = false
			this.dataForm = Object.assign({}, params.row)
		},
		// 编辑
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						this.editLoading = true
						let params = Object.assign({}, this.dataForm)
						this.$wmsApi.tAfaViewWaveOrderLine.save(params).then((res) => {
							if(res.code == 200) {
								this.$message({ message: this.$t("common.message.success")+'', type: 'success' })
				}
else {
								this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				}
this.editLoading = false
							this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							this.findPage(null)
						})
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
    return format(row[column.property])
    }
	},
  activated: function () {
	  this.getParentParams()
  },
  mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TAfaViewWaveOrderLine.vue